export default __webpack_public_path__ + "static/media/08.270f4720.png";